















import { Component, Vue } from 'vue-property-decorator';
import LeafletsModlue from '@/store/modules/leaflets';

@Component
export default class QRCode extends Vue {
  // QRコード用のPDFのURL
  private pdf: string | null = null;

  // QRコード表示
  private show = true;

  // QRコードのサイズ
  private qrcodeSize = 200;

  // QRコードが無効になっていたときのメッセージ
  private disabledMessage = process.env.VUE_APP_QRCODE_DISABLED_MESSAGE;

  // ストアアクションの購読解除関数
  private unsubscribe?: Function;

  activated() {
    this.upload();

    // モジュール監視
    this.unsubscribe = this.$store.subscribe(mutation => {
      if (mutation.type === 'leaflets/setIndex') {
        this.upload();
      }
    });

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  deactivated() {
    this.unsubscribe && this.unsubscribe();
    window.removeEventListener('resize', this.handleResize);
  }

  /**
   * ウィンドウに基づいて新しいキャンバスサイズを計算する
   */
  private handleResize() {
    this.qrcodeSize = Math.floor(this.$el.clientHeight * (234 / 400));
  }

  /**
   * コンテンツ更新
   */
  private upload() {
    this.pdf = LeafletsModlue.pdf;
    const data = LeafletsModlue.current;
    this.show = data !== null ? data.show_qrcode : false;
  }
}
